// @flow
import numeral from 'numeral'

export const shortFormat = (num: number): string => {
  if (num < 1000) return numeral(num).format('0')
  if (num < 10000) return numeral(num / 1000).format('0.00') + 'K'
  if (num < 100000) return numeral(num / 1000).format('0.0') + 'K'
  if (num < 1000000) return numeral(num / 1000).format('0') + 'K'

  return numeral(num / 1000000).format('0.00') + 'M'
}
